/**
 * Validates if the value contains 3 or more repeated digits.
 * @example "1112" -> true
 */
export const validateRepeated = (value: string) => {
    for (let i = 0; i <= value.length - 3; i++) {
        if (value[i] === value[i + 1] && value[i] === value[i + 2]) {
            return true;
        }
    }
    return false;
};

/**
 * Validates if the value contains 3 or more consecutive digits (ascending or descending).
 * @example "1234" -> true, "4321" -> true
 */
export const validateConsecutive = (value: string) => {
    for (let i = 0; i <= value.length - 3; i++) {
        const n1 = parseInt(value[i] || '0');
        const n2 = parseInt(value[i + 1] || '0');
        const n3 = parseInt(value[i + 2] || '0');

        // Ascending: 123
        if (n2 === n1 + 1 && n3 === n2 + 1) return true;
        // Descending: 321
        if (n2 === n1 - 1 && n3 === n2 - 1) return true;
    }
    return false;
};
